import { CSSProperties } from "react";

const palette = {
    light: {
        pageBg: "#F7F7F7",
        headerBg: "#ffffff",
        headerBorder: "#dddddd",
        headerText: "#2c2c2c",
        footerBg: "#FDFCFC",
        footerBorder: "#dddddd",
        footerText: "#807676",
        sectionBg: "#ffffff",
        sectionShadow: "0 3px 6px rgba(0,0,0,0.1)",
        cardBg: "#ffffff",
        cardBorder: "#eeeeee",
        cardText: "#333333",
        cardIcon: "#605859",
        cardShadow: "0 1px 3px rgba(0,0,0,0.08)",
        menuBg: "#ffffff",
        menuText: "#333333",
        menuBorder: "transparent",
    },
    dark: {
        pageBg: "#0d0e1b",
        headerBg: "#0d0e1b",
        headerBorder: "#2e2f46",
        headerText: "#e8e9f4",
        footerBg: "#0d0e1b",
        footerBorder: "#2e2f46",
        footerText: "#9fa7a5",
        sectionBg: "#151625",
        sectionShadow: "0 3px 6px rgba(0,0,0,0.35)",
        cardBg: "#151625",
        cardBorder: "#2e2f46",
        cardText: "#e8e9f4",
        cardIcon: "#9fa7a5",
        cardShadow: "0 1px 3px rgba(0,0,0,0.35)",
        menuBg: "#0d0e1b",
        menuText: "#ffffff",
        menuBorder: "#2e2f46",
    },
} as const;

export function getAppStyles(isDarkMode: boolean) {
    const c = isDarkMode ? palette.dark : palette.light;

    return {
        root: {
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
            backgroundColor: c.pageBg,
            color: isDarkMode ? "#e8e9f4" : "#2c2c2c",
            transition: "background-color 0.3s ease, color 0.3s ease",
        } as CSSProperties,

        main: {
            flex: 1,
            padding: "20px",
            backgroundColor: c.pageBg,
            transition: "background-color 0.3s ease",
        } as CSSProperties,

        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: c.headerBg,
            padding: "10px 0",
            borderBottom: `1px solid ${c.headerBorder}`,
            transition: "background-color 0.3s ease, border-color 0.3s ease",
        } as CSSProperties,

        headerText: {
            marginLeft: "40px",
            color: c.headerText,
        } as CSSProperties,

        footer: {
            textAlign: "center",
            background: c.footerBg,
            borderTop: `1px solid ${c.footerBorder}`,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            transition: "background-color 0.3s ease, border-color 0.3s ease",
        } as CSSProperties,

        section: {
            borderRadius: "16px",
            marginBottom: "20px",
            backgroundColor: c.sectionBg,
            boxShadow: c.sectionShadow,
            transition: "background-color 0.3s ease, box-shadow 0.3s ease",
        } as CSSProperties,

        card: {
            borderRadius: "16px",
            padding: "15px",
            textAlign: "center",
            textDecoration: "none",
            width: "100%",
            maxWidth: "240px",
            boxShadow: c.cardShadow,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: c.cardBg,
            color: c.cardText,
            transition: "transform 0.2s, box-shadow 0.2s, background-color 0.2s, border-color 0.2s",
        } as CSSProperties,

        menu: {
            position: "absolute",
            right: 0,
            top: "110%",
            backgroundColor: c.menuBg,
            borderRadius: isDarkMode ? "16px" : "8px",
            border: isDarkMode ? `1px solid ${c.menuBorder}` : undefined,
            boxShadow: isDarkMode
                ? "0 2px 10px rgba(0,0,0,0.4)"
                : "0 2px 10px rgba(0,0,0,0.1)",
            overflow: "hidden",
            minWidth: "180px",
            zIndex: 100,
        } as CSSProperties,

        menuItem: {
            padding: "10px 16px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px",
            color: c.menuText,
            transition: "background 0.2s",
        } as CSSProperties,

        colors: c,
    };
}
